<template>
    <div>
        <div v-for="(entry,index) in links" :key="entry.id" style="background:white;padding:4px;border:1px solid gray;">
            <post-link :init-data="entry" :show-update="true" :show-remove="true" :show-create="false" v-on:setimgclicked="setImgClicked" v-on:updateclicked="updateClicked" v-on:createclicked="createClicked" v-on:removeclicked="removeClicked" ></post-link>
        </div>

    </div>
</template>
<script>
    import postLink from '../../dashboards/postLink';

    export default {
        components: {
            postLink: postLink
        },
        props: {
            links: Array
        },
        computed: {
            
        },
        methods: {
            setImgClicked: function (e) {
                this.$emit("setimgclicked", e);
            },
            updateClicked: function (e) {
                this.$emit("updateclicked", e);
            },
            createClicked: function (e) {
                this.$emit("createclicked", e);
            },
            removeClicked: function (e) {
                this.$emit("removeclicked", e);
            }
        }
    }
</script>